import { SvgIcon } from "@mui/material";

function Utube(props) {
  return (
    <SvgIcon viewBox="0 0 58 58" {...props}>
      <path d="M33.8424 28.4955L27.0576 25.3297C26.4655 25.0548 25.9792 25.3629 25.9792 26.0184V31.9816C25.9792 32.6371 26.4655 32.9452 27.0576 32.6703L33.8394 29.5045C34.4345 29.2266 34.4345 28.7734 33.8424 28.4955ZM29 0C12.9835 0 0 12.9835 0 29C0 45.0165 12.9835 58 29 58C45.0165 58 58 45.0165 58 29C58 12.9835 45.0165 0 29 0ZM29 40.7812C14.1556 40.7812 13.8958 39.443 13.8958 29C13.8958 18.557 14.1556 17.2187 29 17.2187C43.8444 17.2187 44.1042 18.557 44.1042 29C44.1042 39.443 43.8444 40.7812 29 40.7812Z" />
    </SvgIcon>
  );
}

export default Utube;
